// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"605":"d5ed4cb3","2232":"61b1d26f","3824":"1207dd3e","4422":"7c4a14a8","7372":"885a5bc0"}[chunkId] + ".chunk.css";
};